import * as React from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles } from "@material-ui/core/styles";
import brandTheme from 'brandTheme/Theme';

const useStyles = makeStyles((theme) => ({
    tableContianer:{
      fontFamily:brandTheme.font.poppins,
        maxHeight:'465px',
        '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: brandTheme.tableBackgroundColor,  // scroll bar color
        },
        '&::-webkit-scrollbar': {  /* Works on scrollbar for Chrome, Safari and Opera */
            height: '2px',
            width: '10px',
            backgroundColor: 'transparent',
        },
        '&::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: 'transparent',
        },
        "& .MuiTableCell-root": {
          fontFamily: brandTheme.font.poppinsBold,
          color:brandTheme.black,
        },
        "& .MuiTableCell-stickyHeader": {
          backgroundColor: brandTheme.tableHeaderColor,
        },
        "& .MuiTableRow-root.MuiTableRow-hover:hover":{
          backgroundColor:brandTheme.tableHoverColor
        }
    },
    tableCell:{
      '@media screen and (max-width: 1200px)': {
        padding:'5px',
        fontSize:'12px',
      }
    },
    tableRow:{
      padding:'5px 20px 5px 17px',
      '@media screen and (max-width: 1200px)': {
        padding:'5px',
        fontSize:'12px',
      },
      '& button':{
        padding:'10px 20px',
        minWidth:'92px',
        boxShadow:'inherit',
        color:brandTheme.white,
        margin:"0 5px 5px 0 ",
        height:"40px",
        backgroundColor:brandTheme.buttonColor,
        '&:hover':{
          backgroundColor:brandTheme.buttonHoverColor, 
          boxShadow:'inherit',
        },
        '&:focus':{
          backgroundColor:brandTheme.buttonHoverColor, 
          boxShadow:'inherit',
        }
      },
    },
    tableMainContainer:{
      boxShadow:'inherit',
      margin:"0px auto",
      '@media screen and (max-width: 1200px)': {
          width:'95% !important'
      },
    }
  }));



const ColumnGroupingTable=({columns, rows ,styles, onClickUpdateData, flag, noPagination})=> {
    const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
const onClickFunction = (row)=>{
  if(flag==="inporcess"){
    onClickUpdateData(
      row.leadid,
      row.formNumber,
      "INPROCESS",
      "adharDetailsClear",
      row.mobileNum,
      row.totalCollateralValue,
      row?.branchCode,
      row?.applicationType,
      row?.applicationSubType,
    )
  }else if(flag==="submitted"){
    onClickUpdateData(
      row.applicationid,
      row.accountNumber,
      row.totalCollateralValue,
    )
  }else if(flag==="collateralEvaluation"){
    onClickUpdateData(
      row.applicationid,
      row.formNumber,
      row.accountNumber,
      row.level,
      row.mandatory,
    )
  }else if(flag==="preSanction"){
    onClickUpdateData(
      row.applicationid,
      row.formNumber,
      row.accountNumber,
      row.collateralDescp,
      row.deviation,
      row.customerName,
    )
  }else if(flag==="deviation"){
    onClickUpdateData(
      row.leadId,
      row.id,
      row.deviationJson
    )
  }else if(flag==="collateralApproval"){
    onClickUpdateData(
      row.leadId,
      row.id,
    )
  }else if(flag==="approval"){
    onClickUpdateData(
      row.applicationid,
      row.formNumber,
      row.accountNumber,
      row.totalCollateralValue,
    )
  }else if(flag==="discrepancy"){
    onClickUpdateData(
      row.applicationid,
      row.formNumber,
      row.accountNumber,
      row.totalCollateralValue,
    )
  }
  else if(flag==="disbursal" || flag === "disburseToLms"){
    onClickUpdateData(
      row.applicationid,
      row.formNumber,
      row.customerid,
      row.accountNumber,
      row.totalCollateralValue,
      row.initiator,
      row.mobile,
      row?.branchCode,
      row?.disbursalAmount,
    )
  }
  else if(flag==="completed" || flag==="rejected"){
    onClickUpdateData(
      row.applicationid,
      row.customerid,
      row.accountNumber,
      row.totalCollateralValue,
      row?.disbursalLoanAmount,
    )
  }else if(flag==="personalLoan"){
    onClickUpdateData(
      row.leadid,
      "INPROCESS",
    )
  }
}
  return (
    <Paper className={classes.tableMainContainer} style={{width:styles?"98%":"90%"}}>
      <TableContainer className={classes.tableContianer}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column, index) => (
                <TableCell
                  key={index}
                  align={column.align}
                  className={classes.tableCell}
                  // style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}  
                    onClick={(e) => {
                      if (e.defaultPrevented) return;       
                      onClickUpdateData && onClickFunction(row);
                    }}
                    style={{
                      cursor: onClickUpdateData ? "pointer" : "default",
                      backgroundColor: row.hasSendBackHistory
                      ? "#FFF0F0"
                      : undefined,
                      }}
                    >
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align} className={classes.tableRow}>
                          {
                            React.isValidElement(value)
                              ? value
                              : column.format && typeof value === "number"
                                ? column.format(value)
                                : value
                          }
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
     {!noPagination &&  <TablePagination
        rowsPerPageOptions={[8 , 20]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />}
    </Paper>
  );
}
export default ColumnGroupingTable;